import React from 'react';

export default React.createContext({
  isTestMode: false,
  isTrial: false,
});
